import angular from 'angular';
import uiRouter from 'angular-ui-router';
import auditresultsummaryComponent from './auditresultsummary.component';

let auditresultsummaryModule = angular.module('auditresultsummary', [
  uiRouter
])

.component('auditresultsummary', auditresultsummaryComponent);

export default auditresultsummaryModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/auditresultsummary/auditresultsummary.js